import globalSummit from "./images/globalSummit.jpg";
import srinivasChary from "./images/srinivasChary.jpg";
import awardReception from "./images/awardReception.jpg";
import dumpyard from "./images/dumpyard.jpg";
import fecalSludge from "./images/fecalSludge.jpg";
import jitendraSingh from "./images/jitendraSingh.jpg";
import governmentProject from "./images/governmentProject.jpg";
import wasteWater from "./images/wasteWater.jpg";
import remoteVillage from "./images/remoteVillage.jpg";
import armedForces from "./images/armedForces.jpeg";
import aruthchelvan from "./images/aruthchelvan.jpg";
import certificate from "./images/certificate.jpg";
import districtCollector from "./images/districtCollector.jpg";
import iasPrashant from "./images/iasPrashant.jpg";
import isroReccomendation from "./images/isroReccomendation.jpg";
import journalAcknowledgement from "./images/journalAcknowledgement.jpg";
import mario from "./images/mario.jpg";
import memberOfParliament from "./images/memberOfParliament.jpg";
import pattajoshi from "./images/pattajoshi.jpg";
import prashanjeetMondal from "./images/prashanjeetMondal.jpg";
import sankarGanesh from "./images/sankarGanesh.jpg";
import thirumula from "./images/thirumula.jpg";
import viceChancellor from "./images/viceChancellor.jpg";
import journalAckPlant from "./images/Journal_acknowledgment_plant.png";
import graduationBits from "./images/graduation_bits.png";
import citation from "./images/citation.png";
import sana from "./images/sana_reactor.png";
import sanaNews from "./images/sana_news.png";
import ieee from "./images/ieee.png";
import bitsology from "./images/bitsology.png";
import futureEarth from "./images/futureEarth.png";
import plosSustainablity from "./images/plosSustainablity.png";
import plosBottomSlider from "./images/plosBottomSlider.jpeg";
import centerOfScience from "./images/centerOfScience.png";
import LetterofRecommendationfromIITJodhpur from "./images/LetterofRecommendationfromIITJodhpur.png";
import LetterofRecommendationfromNEERI from "./images/LetterofRecommendationfromNEERI.png";
import LetterofRecommendationfromOsmaniaUniversity from "./images/LetterofRecommendationfromOsmaniaUniversity.png";
import IGSD from "./images/IGSD.jpeg";
import Forward from "./images/Forward.png";
import ForewardProvidedbyMsNamitaBanka from "./images/ForewardProvidedbyMsNamitaBanka.png";
import DrAmitKesarkar from "./images/DrAmitKesarkar.png";
import scientistofCSE from "./images/scientistofCSE.png";
import IWFGlobalAwards2026 from "./images/IWFGlobalAwards2026.png";

const achivements = [
  {
    url: globalSummit,
    desc: "Attending a global summit at Delhi",
  },
  {
    url: srinivasChary,
    desc: "Attending Inkwash with Professor V. Srinivas Chary",
  },
  {
    url: awardReception,
    desc: "Award reception",
  },
  {
    url: dumpyard,
    desc: "Dumpyard Remediation project at Kurnool, AP",
  },
  {
    url: graduationBits,
    desc: "Graduation Convocation @ BITS Pilani",
  },
  {
    url: fecalSludge,
    desc: "Fecal Sludge Treatment Facility Inspection with Officials from ASCI",
  },
  {
    url: jitendraSingh,
    desc: "in talks with Padma Shri Shree Jitender Singh Shunty (COVID Warrior)",
  },
  {
    url: governmentProject,
    desc: "Obtained MoU with Goverment Agency for Environmental Projects",
  },
  {
    url: wasteWater,
    desc: "Social Project on Wastewater Contamination during COVID",
  },
  {
    url: remoteVillage,
    desc: "Wastewater Sample Sampling in remote village of AP",
  },
  {
    url: sana,
    desc: "sana reactor developed at Bits",
  },
  {
    url: ieee,
    desc: "A day celebrated at BLRIT as a keynote Speaker",
  },
  {
    url: bitsology,
    desc: "Featured in Bitsology Volume 1.9",
  },
  {
    url: IWFGlobalAwards2026,
    desc: "Conferred Prestihious",
  },
];

export const certificates = [
  {
    url: armedForces,
  },
  {
    url: aruthchelvan,
  },
  {
    url: certificate,
  },
  {
    url: districtCollector,
  },
  {
    url: iasPrashant,
  },
  {
    url: isroReccomendation,
  },
  {
    url: journalAcknowledgement,
  },
  {
    url: mario,
  },
  {
    url: memberOfParliament,
  },
  {
    url: pattajoshi,
  },
  {
    url: prashanjeetMondal,
  },
  {
    url: sankarGanesh,
  },
  {
    url: thirumula,
  },
  {
    url: viceChancellor,
  },
  {
    url: journalAckPlant,
  },
  {
    url: citation,
  },
  {
    url: sanaNews,
  },
  {
    url: futureEarth,
  },
  {
    url: plosSustainablity,
  },
  {
    url: plosBottomSlider,
  },
  {
    url: centerOfScience,
  },
  {
    url: LetterofRecommendationfromOsmaniaUniversity,
  },
  {
    url: LetterofRecommendationfromNEERI,
  },
  {
    url: LetterofRecommendationfromIITJodhpur,
  },
  {
    url: IGSD,
  },
  {
    url: Forward,
  },
  {
    url: ForewardProvidedbyMsNamitaBanka,
  },
  {
    url: DrAmitKesarkar,
  },
  {
    url: scientistofCSE,
  },
];
export default achivements;
